import "./vue.js";
import * as THREE from "three";
window.THREE = THREE;